import request, { BASE_URL } from './request'

export enum SettingName {
  WIN_POINTS = 'win_points',
  REFERRAL_POINTS = 'referral_points',
}

export interface Setting {
  id: string
  created_at: string
  updated_at: string
  name: SettingName
  value: string
}

export interface SettingsResponse {
  items: Setting[]
  count: number
}

export const getSettings = async (): Promise<SettingsResponse> =>
  request({
    method: 'GET',
    url: `${BASE_URL}/settings`,
  })
